<script>

    import Moment from 'moment'
    import { createEventDispatcher } from 'svelte'
    import { toast } from 'bulma-toast'
    import { PickupsStore, ShipmentStore } from '../stores'

    import PickupsService from '../$services/pickups.service'

    import LocationMap from '../locations/location.map.svelte'
    import InputEmail from '../$components/input.email.svelte'
    import InputPhone from '../$components/input.phone.svelte'
    import InputNumber from '../$components/input.number.svelte'
    import InputText from '../$components/input.text.svelte'
    import Date from '../$components/date.svelte'
    import Form from '../$components/form.svelte'

    const dispatch = createEventDispatcher()

    let loading = false
    let data = {
        date: Moment().add(1, 'day').toDate(),
        guide: $ShipmentStore.guide,
        location: {
            ...$ShipmentStore.pickup,
            coordinates: {
                lat: $ShipmentStore.pickup.position.coordinates[1],
                lng: $ShipmentStore.pickup.position.coordinates[0],
            }
        },
        package: $ShipmentStore.package,
    }

    async function createPickup() {

        loading = true
        const resp = await PickupsService.createPickup(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        PickupsStore.append(resp.data)

        toast({message: 'Recolección creada', type: 'is-success'})
        dispatch('created', resp.data)
    }

</script>

<Form on:submit={createPickup} on:canceled { loading } >
    
    <LocationMap label="Dirección" alias={false} bind:data={ data.location } />

    <hr>

    {#if data.location.placeId || data.location.address}
        <div class="columns">
            <div class="column">
                <InputText bind:value={data.guide} label="Número de guía" icon="qrcode" placeholder="Número de guía" />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <Date bind:value={data.date} label="Fecha de recolección" />
            </div>
        </div>
        <hr>
        <div class="columns">
            <div class="column">
                <InputText bind:value={data.location.contact} label="Contacto" icon="user" placeholder="Contacto" />
            </div>
            <div class="column">
                <InputText bind:value={data.location.company} label="Empresa" icon="building" placeholder="Empresa" required={false} />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <InputText bind:value={data.location.rfc} label="RFC" icon="fingerprint" placeholder="RFC" />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <InputPhone bind:value={data.location.phone} label="Teléfono" />
            </div>
            <div class="column">
                <InputEmail bind:value={data.location.email} label="Correo" />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <InputText bind:value={data.location.zipcode} label="Código postal" icon="map-marker-alt" placeholder="Código postal" />
            </div>
            <div class="column">
                <InputText bind:value={data.location.state} label="Estado" icon="map-marker-alt" placeholder="Estado" />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <InputText bind:value={data.location.city} label="Ciudad" icon="map-marker-alt" placeholder="Ciudad" />
            </div>
            <div class="column">
                <InputText bind:value={data.location.municipality} label="Municipio" icon="map-marker-alt" placeholder="Municipio" required={false} />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <InputText bind:value={data.location.colony} label="Colonia" icon="map-marker-alt" placeholder="Colonia" />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <InputText bind:value={data.location.street} label="Calle" icon="map-marker-alt" placeholder="Calle" />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <InputText bind:value={data.location.number} label="Número exterior" icon="hashtag" placeholder="Número exterior" />
            </div>
            <div class="column">
                <InputText bind:value={data.location.apartment} label="Número interior" icon="building" placeholder="Número interior" required={false} />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <InputText bind:value={data.location.references} label="Referencias" icon="asterisk" placeholder="Referencias" />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <InputText bind:value={data.location.betweenStreets} label="Entre calles" icon="asterisk" placeholder="Entre calles" />
            </div>
        </div>

        <div class="subtitle"><b>Medidas promedio de los paquetes</b></div>
        <hr>
        <div class="columns">
            <div class="column">
                <InputNumber bind:value={data.package.width} label="Ancho" icon="ruler-horizontal" placeholder="CM" />
            </div>
            <div class="column">
                <InputNumber bind:value={data.package.height} label="Alto" icon="ruler-vertical" placeholder="CM" />
            </div>
            <div class="column">
                <InputNumber bind:value={data.package.length} label="Largo" icon="ruler" placeholder="CM" />
            </div>
            <div class="column">
                <InputNumber bind:value={data.package.weight} label="Peso" icon="weight" placeholder="KG" />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <InputText bind:value={data.package.content} label="Contenido" icon="asterisk" placeholder="Contenido" />
            </div>
            <div class="column">
                <InputNumber bind:value={data.package.total} label="Paquetes" icon="list-ol" placeholder="Total de paquetes" />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <InputText bind:value={data.notes} label="Notas importantes para el repartidor" icon="asterisk" placeholder="Notas importantes para el repartidor" />
            </div>
        </div>
    {/if}
</Form>